export default __webpack_public_path__ + "static/media/chd.0adac2cd.svg";